import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { of, tap, catchError, Observable } from 'rxjs';

import { CheckInviteResponse } from '@shared/invite/models';
import { CurrentInviteService } from './current-invite.service';
import { PublicInviteApiService } from '../services';
import { AuthService } from '@tablesready/frontend-auth';

@Injectable({ providedIn: 'root' })
export class InviteResolver implements Resolve<CheckInviteResponse> {

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly publicInviteApiService: PublicInviteApiService,
    private readonly currentInviteService: CurrentInviteService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<CheckInviteResponse> {
    const { queryParamMap } = route;
    const token = queryParamMap.get('token');

    return this.publicInviteApiService.check(token)
      .pipe(
        tap(invite => {
          const { inviteForNewUser } = invite;

          if (inviteForNewUser) {
            this.currentInviteService.setValue(invite);
            return;
          }

          const isAuthenticated = this.authService.isAuthenticated();
          const navigatePath = isAuthenticated
            ? '/settings/account/profile?accountsAccessTab=true'
            : '/login?navigateToProfile=true';

          this.router.navigateByUrl(navigatePath);
        }),
        catchError(() => {
          this.router.navigateByUrl('/invite/not-found');

          return of(null);
        }),
      );
  }
}
